@if (isAdmin) {
    <sm-toolbar>
        <p-button severity="warn" icon="fas fa-cog" label="Administration" (onClick)="adminClick()">
        </p-button>
    </sm-toolbar>
}
<p-card header="Bitte wählen Sie eine Klasse aus">
    <app-school-class-list [schoolClasses]="schoolClasses" baseUrl="/enaio-certificates/pupils" [isHalfYear]="isHalfYear"></app-school-class-list>    
</p-card>
